import { Form } from 'componentregistry';
import { memoize } from '@cloudio-saas/statex';
import { FormHelperText, FormLabel, Grid } from '@mui/material';
import React from 'react';

const _memoGetLabelStyle = memoize(
  (
    id: string,
    {
      labelAlignment,
      labelWidth,
    }: Pick<Form.Form, 'labelAlignment' | 'labelWidth'>,
  ): React.CSSProperties => {
    return {
      overflow: 'hidden',
      paddingRight: 16,
      textAlign: labelAlignment,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: labelWidth,
    };
  },
);

export function getLabelStyle({
  labelAlignment,
  labelWidth,
}: Pick<Form.Form, 'labelAlignment' | 'labelWidth'>): React.CSSProperties {
  return _memoGetLabelStyle(`${labelAlignment}:${labelWidth}`, {
    labelAlignment,
    labelWidth,
  });
}

interface Props extends Pick<Form.Form, 'labelAlignment' | 'labelWidth'> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: React.ReactElement<any, any>;
  helperText?: string;
  label?: string;
  required: boolean;
  labelColor?: string;
  fontWeight?: number;
  fontStyle?: boolean;
  id: string;
}

export function HorizontalFormField({
  control,
  helperText,
  label,
  labelAlignment,
  labelWidth,
  error,
  required,
  labelColor,
  fontWeight,
  fontStyle,
  id,
}: Props & { error?: boolean }): React.ReactElement {
  return (
    <Grid container alignItems="flex-start">
      <Grid
        item
        style={getLabelStyle({
          labelAlignment,
          labelWidth,
        })}
        // clicking on the label would also click on the control and hence two events would be fired... hence we use nocapture for the label
        data-nocapture
      >
        <FormLabel
          htmlFor={id}
          required={required}
          error={error}
          sx={{
            color: labelColor,
            fontWeight: fontWeight,
            fontStyle: fontStyle ? 'italic' : undefined,
          }}
        >
          {label}
        </FormLabel>
      </Grid>
      <Grid item xs>
        {control}
        {helperText ? (
          <FormHelperText error={error}>{helperText}</FormHelperText>
        ) : null}
      </Grid>
    </Grid>
  );
}
